/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IAwardPeriodDataState } from "Interfaces/SiteContent/IAwardPeriodDataState";

import { IGetAwardPeriodsFailure, IGetAwardPeriodsSuccess } from "./AwardPeriodAction";
import { AWARD_PERIOD_LOAD_FAILURE, AWARD_PERIOD_LOAD_SUCCESS } from "./AwardPeriodActionTypes";

const initialState: IAwardPeriodDataState = {
  awardPeriodOptionList: [],
  awardPeriodLoadError: "",
};

/**
 * Updates state of fetch award periods success.
 * @param {IAwardPeriodDataState} state The award periods state.
 * @param {IGetAwardPeriodsSuccess} action The award periods action success.
 * @returns {IAwardPeriodDataState} New award periods state.
 */
const applyLoadAwardPeriods = (
  state: IAwardPeriodDataState,
  action: IGetAwardPeriodsSuccess
): IAwardPeriodDataState => ({
  ...state,
  awardPeriodOptionList: action.awardPeriods,
});

/**
 * Updates state of fetch award periods failure.
 * @param {IAwardPeriodDataState} state The award periods state.
 * @param {IGetAwardPeriodsFailure} action The award periods action failure.
 * @returns {IAwardPeriodDataState} New award periods state.
 */
const applyLoadAwardPeriodsFail = (
  state: IAwardPeriodDataState,
  action: IGetAwardPeriodsFailure
): IAwardPeriodDataState => ({
  ...state,
  awardPeriodLoadError: action.awardPeriodLoadError,
});

/**
 * Reducer function for Activity component.
 * @param {IAwardPeriodDataState} state The activity state.
 * @param {AwardPeriodActionTypes} action The action type.
 * @returns {IAwardPeriodDataState} The activity state.
 */

function awardPeriodReducer(
  state: IAwardPeriodDataState = initialState,
  action
): IAwardPeriodDataState {
  switch (action.type) {
    case AWARD_PERIOD_LOAD_SUCCESS:
      return applyLoadAwardPeriods(state, action);
    case AWARD_PERIOD_LOAD_FAILURE:
      return applyLoadAwardPeriodsFail(state, action);
    default:
      return state;
  }
}

export default awardPeriodReducer;
